import { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
}
const CustomContainer: FC<Props> = ({ children }) => {
  return <div className="container bg-light p-1">{children}</div>;
};

export default CustomContainer;
